import React from 'react';
import { compose, withHandlers } from 'recompose';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import LockIcon from '@material-ui/icons/LockOutlined';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import { TextField } from 'redux-form-material-ui';
import { withSnackbar } from 'notistack';
import withLoader from '../app/withLoader';
import { login, loadUser } from './_api';
import { attributes } from '../app/_api';

const styles = theme => ({
  layout: {
    width: 'auto',
    display: 'block', // Fix IE11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE11 issue.
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },

  textFields: {
    margin: 10,
  },
});

const enhance = compose(
  withStyles(styles),
  withSnackbar,
  withLoader,
  connect(
    null,
    { loadUser, attributes },
  ),
  withHandlers({
    onSubmit: ({ toggleLoader, loadUser, attributes, enqueueSnackbar }) => async values => {
      toggleLoader();
      const resp = await login(values);
      if (resp.success) {
        await loadUser();
        await attributes();
      } else {
        enqueueSnackbar('Přihlášení se nezdařilo.', { variant: 'error' });
      }
      toggleLoader(false);
    },
  }),
  reduxForm({ form: 'loginForm' }),
);

export default enhance(({ classes, handleSubmit }) => (
  <React.Fragment>
    <CssBaseline />
    <main className={classes.layout}>
      <Paper className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockIcon />
        </Avatar>
        <Typography variant="h5">Přihlášení</Typography>
        <form className={classes.form} onSubmit={handleSubmit}>
          <Field
            name="username"
            component={TextField}
            label="Login"
            fullWidth
            className={classes.textFields}
          />
          <Field
            name="password"
            component={TextField}
            label="Heslo"
            fullWidth
            type="password"
            className={classes.textFields}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Přihlásit se
          </Button>
        </form>
      </Paper>
    </main>
  </React.Fragment>
));



// WEBPACK FOOTER //
// ./src/modules/login/index.js